/**
 * @功能名称:
 * @文件名称: funddebug-conf.js
 * @Date: 2019/5/8 下午5:20.
 * @Author: hengbao
 * @Copyright（C）: 2019 X-Financial Inc.   All rights reserved.
 * 注意：本内容仅限于小赢科技有限责任公司内部传阅，禁止外泄以及用于其他的商业目的。
 * 项目名称：wallet_app
 */

import  fundebugFn from "bjxy-common/xyHelper/fundebug"

fundebugFn({
  apikey : "dde85c3940e8f877a0f638a8720c2ae57b33f075ff398a3b3c54c6f671972051",
  filters :[
    {
      message: /JSBridge|vivoNewsDetailPage|setWebViewFlag|TouTiao|onHidden|on_page_disappear|_setbackXML_|processRandomSelector|bridge|jsOnMessage|pajkOnMessage|x5onSkinSwitch|getElementById|getAndroidUnionSeries|MPing|property|BecomeActive|ResignActive|_plusready_dispatch|onAudioStateChanged|goToGetres|appWebGLStart|appWebGLStop|vivo|qbSniffJsVersion|\(null\)\sis\snot\sa\sfunction/
    },
    {
      res: {
        elapsedTime: /\d{0}[3-9]\d{4,}/
      }
    },
    {
      target: {
        src: /revideo/
      }
    },
    {
      name: /unhandledrejection/
    },
    {
      message: /_mz_getNextLink|hwbrNotifyScreenConfigChanged|_thisFormClient_|mttLongPressVar/
    }
  ]})



// WEBPACK FOOTER //
// ./src/asset/vendor/funddebug-conf.js